/* eslint import/prefer-default-export: 0 */

export function getSectionAdditionalClasses(sectionClasses, sectionOpened, currentSection, referenceSection) {
    sectionClasses.push(sectionOpened ? 'open' : 'close');
    if (referenceSection < currentSection) {
        sectionClasses.push('active');
    }

    return sectionClasses;
}
